/**
* Three Column Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the Three Column Cards component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'three-column-cards',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.js-anim-group' ).each( function() {
        const $group = $( this );
        const targets = $group.find( '.js-anim-target' ).filter( ':not(.js-ignore)' ).toArray();
        if ( !targets.length ) return;

        gsap.set( targets, {autoAlpha: 0, y: 20} );

        ScrollTrigger.create( {
          trigger: this,
          start: 'top 60%',
          onEnter: () => {
            gsap.to( targets, {
              autoAlpha: 1,
              y: 0,
              duration: 0.6,
              stagger: 0.12,
              ease: 'power2.out',
              overwrite: true,
            } );
            $group.addClass( 'js-animated' );
          },
          onEnterBack: () => {
            gsap.to( targets, {
              autoAlpha: 1,
              y: 0,
              duration: 0.6,
              stagger: 0.12,
              ease: 'power2.out',
              overwrite: true,
            } );
            $group.addClass( 'js-animated' );
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'three-column-cards', COMPONENT );
} )( app );
